import { render, staticRenderFns } from "./InputRadio.vue?vue&type=template&id=56c6d37b&scoped=true"
import script from "./InputRadio.vue?vue&type=script&lang=js"
export * from "./InputRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c6d37b",
  null
  
)

export default component.exports